export default __webpack_public_path__ + "static/sacfiscal-302f8dc8c28c651705ae778c8e314251.png";